import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62a0c16d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  style: {"font-size":"16px","margin-top":"35px","margin-bottom":"35px","text-align":"start","width":"95%","max-lines":"4"}
}
const _hoisted_4 = {
  key: 1,
  style: {"font-size":"24px","margin-top":"35px","margin-bottom":"35px"}
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "club-voucher-actions-footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewHeader = _resolveComponent("ViewHeader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ViewHeader),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.club?.instruction)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.club.instruction), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('club.scan.manual.title')), 1)),
        (_ctx.club?.photoInstructions.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.club?.photoInstructions, (photo, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("img", {
                    src: photo,
                    width: "368",
                    height: "170",
                    style: {"margin-bottom":"35px"}
                  }, null, 8, _hoisted_6)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_7
    ])
  ]))
}